// extracted by mini-css-extract-plugin
export var errorsContainer = "_uo-1";
export var link = "_uo-0";